export enum ROUTE_PATHS {
  MAIN = '/',

  DESKTOP = '/desktop',
  DESKTOP_QR = '/desktop-qr',

  CATEGORY = '/category',
  GAMES = '/games',
  SEARCH = '/search',
  GAME_REQUEST = '/game-request',

  // keep wheel route because there are external links to it
  WHEEL = '/wheel',
  // prize page can be nested for any route
  PRIZE = 'prize',

  // lootbox page can be nested for any route
  LOOTBOX = 'lootbox',

  PROFILE = '/profile',
  SETTINGS = '/settings',
  PROGRESS = '/progress',

  TASKS = '/tasks',
  POLL = '/poll',

  FEED = '/feed',
  SHOP = '/shop',
  WALLET = '/wallet',

  LEADERBOARDS = '/leaderboards',
  REFERRAL_PROGRAMM = '/referral-program',

  ONBOARDING = '/onboarding',

  DEV = '/dev',
  STORYBOOK = 'storybook',

  TERMS_CONDITIONS = '/terms-and-conditions',

  // can be opened from any page
  CLICKER = 'clicker',

  DAYS_STREAK = '/days-streak',

  LISTING = '/listing',

  NOT_FOUND = '*',
}
